
import 'components/catalog.tag'
import 'pages/products/options/option-group-new-modal.tag'
riot.tag2('options-groups-list', '  <catalog object="OptionGroup" cols="{cols}" search="true" add="{permission(addEdit , &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;products&quot;, &quot;1000&quot;)}" reorder="true" reload="true" store="parameters-groups-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="sort">{row.sort}</datatable-cell>\n      <datatable-cell name="description">{row.description}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'OptionGroup';

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'sort', value: 'Индекс' }, { name: 'description', value: 'Описание' }];

self.addEdit = function (e) {
    var id;
    if (e.item && e.item.row) {
        id = e.item.row.id;
    }

    modals.create('option-group-new-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var _this = this;
            var params = _this.item;

            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'OptionGroup',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        }
    });
};

self.one('updated', function () {
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'OptionGroup',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });

        self.update();
    });
});

observable.on('options-groups-reload', function () {
    self.tags.catalog.reload();
});
});


// WEBPACK FOOTER //
// ./pages/products/options/options-groups-list.tag